module.exports = __webpack_public_path__ + "static/media/grain.8eac8d76.svg";